<template>
  <div class="mainbar">
    <div class="m_breadcrumb">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }"><img class="home_img" src="@/assets/img/home.png" alt="" />首页</el-breadcrumb-item>
        <template v-for="(bread, index) of breadList">
          <el-breadcrumb-item :key="index" :to="bread.path" v-if="!['layout', 'container'].includes(bread.name)">
            <a>{{ bread.meta.title.split("-").length > 1 ? bread.meta.title.split("-")[1] : bread.meta.title.split("-")[0] }}</a>
          </el-breadcrumb-item>
        </template>
      </el-breadcrumb>
    </div>
    <div class="main_content">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      breadList: [],
    };
  },
  created() {
    this.breadList = this.$route.matched;
  },
  watch: {
    $route: "buildBreadList",
  },
  methods: {
    buildBreadList() {
      // console.log(this.$route);
      this.breadList = this.$route.matched;
    },
  },
};
</script>

<style lang="scss" scoped>
.mainbar {
  flex: 1;
  // height: calc(100vh - 320px);
  min-height: calc(100vh - 168px);
  background: #fff;
  margin-top: 16px;
  margin-bottom: 16px;
  box-shadow: 0px 2px 24px 1px rgba(0, 0, 0, 0.06);
  margin-left: 16px;
  border-radius: 16px;
  position: relative;
  overflow: hidden;
  .m_breadcrumb {
    padding: 14px 30px;
    border-bottom: 1px solid #f1f1f1;
    .home_img {
      margin-right: 6px;
      height: 14px;
      margin-top: -4px;
    }
  }
  .main_content {
    padding: 20px 30px;
    overflow: auto;
    height: calc(100% - 43px);
  }
}
</style>
